import { cva } from "./index";

export const badgeVariantColors = {
  info: "bg-[var(--color-card-info-bg)] text-[var(--color-card-info-content)]",
  success:
    "bg-[var(--color-card-success-bg)] text-[var(--color-card-success-content)]",
  warning:
    "bg-[var(--color-card-warning-bg)] text-[var(--color-card-warning-content)]",
  problem:
    "bg-[var(--color-card-problem-bg)] text-[var(--color-card-problem-content)]",
  danger:
    "bg-[var(--color-card-danger-bg)] text-[var(--color-card-danger-content)]",
  neutral: "bg-gray-50 text-gray-700",
  walnut: "bg-walnut-50 text-walnut-700",
  obsidian: "bg-obsidian-200 text-obsidian-700",
  muted: "bg-obsidian-50 text-obsidian-900",
  dark: "bg-obsidian-700 text-white",
} as const;

export type BadgeVariant = keyof typeof badgeVariantColors;

export const statusSurface = cva({
  base: "",
  variants: {
    variant: badgeVariantColors,
  },
  defaultVariants: {
    variant: "neutral",
  },
});

export const badge = cva({
  base: "inline-flex w-max max-w-fit items-center gap-1 rounded-sm font-medium",
  variants: {
    variant: badgeVariantColors,
    size: {
      sm: "px-2 py-0.5 text-xs",
      md: "px-4 py-0.5 text-sm",
    },
    ring: {
      true: "ring-1 ring-inset",
      false: "",
    },
  },
  compoundVariants: [
    {
      variant: "success",
      ring: true,
      class: "ring-green-600/20",
    },
  ],
  defaultVariants: {
    variant: "neutral",
    size: "sm",
    ring: false,
  },
});
